class CharLimit {
  constructor(el) {
    this.el = el;
    this.init();
    this.bind();
  }

  init() {
    console.log(this.el);
    this.countDownEl = this.el.parentElement.querySelector('.u-hint');
    this.max = parseInt(this.el.getAttribute('data-charlimit')) | 0;
  }

  bind() {
    this.el.addEventListener('keydown', e => this.update(e));
    this.el.addEventListener('blur', e => this.update(e));
  }

  update(e) {
    var newVal = this.countDownEl.textContent.replace(/-?\d+/, this.max - this.el.value.length);
    this.countDownEl.textContent = newVal;
  }
}


export default CharLimit;



// WEBPACK FOOTER //
// ./scripts/components/charlimit.js